/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Plus_TitleInputs */

const en_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ar_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const de_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const es_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const fr_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const it_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ja_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ko_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const pt_br_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ru_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const th_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const tr_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const zh_cn_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const zh_tw_subscription_service_level_compare_plus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

/**
* | output |
* | --- |
* | "Plus" |
*
* @param {Subscription_Service_Level_Compare_Plus_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_plus_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Plus_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Plus_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_plus_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_plus_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_plus_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_plus_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_plus_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_plus_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_plus_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_plus_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_plus_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_plus_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_plus_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_plus_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_plus_title(inputs)
	return zh_tw_subscription_service_level_compare_plus_title(inputs)
});